import React from 'react';

const steps = [
  {
    number: "1",
    title: "Create Your Account",
    description: "Create one account to manage the health and financial information that matters to you.",
  },
  {
    number: "2",
    title: "Set Up Your Data",
    description: "Add your health information for emergencies, and set up expense groups or cash flow plans for finances.",
  },
  {
    number: "3",
    title: "Access Anytime",
    description: "Share your health QR code in emergencies, split expenses with friends, and monitor your cash flow—all from one unified platform.",
  },
];

const HowItWorksSection = () => {
  return (
    <section id="how-it-works" className="py-20 bg-secondary">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            How It Works
          </h2>
          <p className="text-xl text-gray-400">
            Three simple steps to manage your health and finances
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          {steps.map((step, index) => (
            <div
              key={index}
              className="relative"
            >
              <div className="bg-secondary-dark rounded-lg p-8 relative z-10">
                <div className="text-5xl font-bold text-primary-light mb-4 opacity-50">
                  {step.number}
                </div>
                <h3 className="text-xl font-semibold mb-4">{step.title}</h3>
                <p className="text-gray-400">{step.description}</p>
              </div>
              {index < steps.length - 1 && (
                <div className="hidden md:block absolute top-1/2 right-0 transform translate-x-1/2 -translate-y-1/2 text-primary-light opacity-20">
                  <svg className="w-12 h-12" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                  </svg>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="bg-red-500/10 rounded-lg p-8 border border-red-500/20">
            <h3 className="text-xl font-semibold mb-4 text-red-300">Health App</h3>
            <p className="text-gray-300 mb-4">
              Store critical medical information accessible via QR code. In emergencies, every second counts—the first 5 minutes can be life-saving. 
              Your health data is instantly available to first responders when they need it most.
            </p>
          </div>
          
          <div className="bg-green-500/10 rounded-lg p-8 border border-green-500/20">
            <h3 className="text-xl font-semibold mb-4 text-green-300">Economics App</h3>
            <p className="text-gray-300 mb-4">
              Manage shared expenses and track your cash flow. Split bills with AI receipt scanning, plan recurring expenses, and get weekly financial summaries. 
              No more spreadsheet headaches.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
